import NotificationBlock from 'atoms/NotificationBlock';
import getMdxChildren from 'utils/getMdxChildren';

const InfoBlock: React.FC<{ children: any }> = ({ children }) => {
  if (!children) return null;

  return <NotificationBlock>{getMdxChildren(children)}</NotificationBlock>;
};

export default InfoBlock;
